import moment from "moment";
import React from "react";
import Avatar from "react-avatar";
import { useSelector } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import styles from "./Resource.module.scss";

const ResourceDeatils = (props) => {

    const profileEnm = useSelector(state => state?.resources?.enumData?.role)
    let str = props?.data?.skills;
    let skillData = str?.split(",");

    return (
        <Container className={styles.ResourcePage}>
            <div className={styles.ResourceAvtar}>

                {props?.data?.avtar?.url ?
                    <Avatar
                        className={styles.commentAvt}
                        facebook-id="invalidfacebookusername"
                        src={props?.data?.avtar?.url}
                        size="100"
                        round={true}
                    /> : <Avatar
                        className={styles.commentAvt}
                        name={props?.data?.name+ " " +props?.data?.lastName}
                        maxInitials={2}
                        size="100"
                        round={true}
                    />
                }
                <span className={styles.ResourceAvtarName}>
                    {props?.data?.name} {" "} {props?.data?.lastName}
                </span>
                <span className={styles.ResourceAvtarEamil}>
                    {props?.data?.email}
                </span>

            </div>
            <Row className={styles.ResourceRow}>

                {props?.data?.phone ? (
                    <Col md={6} className={styles.ResourceCol}>
                        <span className={styles.ResourceCardText}>Phone :</span>
                        <span className={styles.ResourceCardTitle}>
                            {props?.data?.phone}
                        </span>
                    </Col>
                ) : (
                    ""
                )}
                {props?.data?.role ? (
                    <Col md={6} className={styles.ResourceCol}>
                        <span className={styles.ResourceCardText}>Role :</span>
                        <span className={styles.ResourceCardTitle}>
                            {props?.data?.atsRole}
                        </span>
                    </Col>
                ) : (
                    ""
                )}

                {props?.data?.dateOfJoining ? (
                    <Col md={6} className={styles.ResourceCol}>
                        <span className={styles.ResourceCardText}>Date of Joining :</span>
                        <span className={styles.ResourceCardTitle}>
                            {moment(props?.data?.dateOfJoining).format("DD/MM/YYYY")}
                        </span>
                    </Col>
                ) : (
                    ""
                )}
                {props?.data?.dob ? (
                    <Col md={6} className={styles.ResourceCol}>
                        <span className={styles.ResourceCardText}>Date of Birth :</span>
                        <span className={styles.ResourceCardTitle}>
                            {moment(props?.data?.dob).format("DD/MM/YYYY")}
                        </span>
                    </Col>
                ) : (
                    ""
                )}

                {props?.data?.experience ? (
                    <Col md={6} className={styles.ResourceCol}>
                        <span className={styles.ResourceCardText}>Previous Experience :</span>
                        <span className={styles.ResourceCardTitle}>
                            {props?.data?.experience}
                        </span>
                    </Col>
                ) : (
                    ""
                )}

                {props?.data?.gexperience?.year || props?.data?.gexperience?.months ? (
                    <Col md={6} className={styles.ResourceCol}>
                        <span className={styles.ResourceCardText}>Company Experience :</span>
                        <span className={styles.ResourceCardTitle}>
                            {props?.data?.gexperience?.year + " Y " + props?.data?.gexperience?.months + " M"}
                        </span>
                    </Col>
                ) : (
                    ""
                )}

                {props?.data?.skills ? (
                    <Col md={12} className={styles.ResourceCol}>
                        <span className={styles.ResourceCardText}>Skills:</span>
                        <div className={styles.ResourceCardSkill}>
                            {skillData?.map((item, i) => (
                                <span className={styles.badge}>{item}</span>
                            ))
                            }
                        </div>
                    </Col>
                ) : (
                    ""
                )}
            </Row>
        </Container>
    );
};

export default ResourceDeatils;
